import * as React from 'react';

import Icon from 'components/atoms/Icon';

export type TopicIconPropsType = {
	categoryIcon: string;
};

const TopicIcon = ({ categoryIcon }: TopicIconPropsType) => (
	<div className="m-card__topic-icon">
		<Icon iconName={categoryIcon} />
	</div>
);

TopicIcon.displayName = 'Card(TopicIcon)';

export default TopicIcon;
